import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { AppEnvironment, AppPlatform, MobileApp } from 'src/app/shared/enums/enums';
import { MobileAppVersionModel } from '../models/upload-build.model';

@Injectable({
  providedIn: 'root',
})
export class UploadBuildService {
  private companyApiUrl = environment.companyApiUrl;
  constructor(private http: HttpClient) {}
  // /MobileAppVersions?MobileApp=1&Platform=1&Environment=1&IsLatest=true
  getBuilds(
    environment: AppEnvironment,
    isLatest?: boolean,
    isBetaVersion?: boolean,
    mobileApp?: MobileApp,
    platform?: AppPlatform,
  ) {
    let url = `${this.companyApiUrl}/MobileAppVersions`;
    const params: string[] = [];

    if (environment !== undefined) {
      params.push(`Environment=${environment}`);
    }
    if (isLatest !== undefined) {
      params.push(`IsLatest=${isLatest}`);
    }
    if (isBetaVersion !== undefined) {
      params.push(`IsBetaVersion=${isBetaVersion}`);
    }
    if (mobileApp !== undefined && mobileApp !== MobileApp.Unknown) {
      params.push(`MobileApp=${mobileApp}`);
    }
    if (platform !== undefined && platform !== AppPlatform.Unknown) {
      params.push(`Platform=${platform}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get(url);
  }
  getBuild(id: number) {
    const url = `${this.companyApiUrl}/MobileAppVersions/${id}`;
    return this.http.get(url);
  }
  add(user: MobileAppVersionModel) {
    const url = `${this.companyApiUrl}/MobileAppVersions`;
    return this.http.post(url, user);
  }

  updateById(user: MobileAppVersionModel, id: number) {
    const url = `${this.companyApiUrl}/MobileAppVersions/${id}`;
    return this.http.put(url, user);
  }

  deleteById(id: number) {
    const url = `${this.companyApiUrl}/MobileAppVersions/${id}`;
    return this.http.delete(url);
  }
  setAsLatest(id: number) {
    const url = `${this.companyApiUrl}/MobileAppVersions/${id}/MarkLatest`;
    return this.http.put(url, null);
  }
  uploadBuild(appName: MobileApp, file: any) {
    const url = `${this.companyApiUrl}/MobileAppVersions/Upload?path=${MobileApp[appName]}`;
    return this.http.post(url, file);
  }
}
